/**
 * AI Recruit - Redux Store Configuration
 * Centralized state management with Redux Toolkit
 * 
 * NO MANUAL RULES - NO FALLBACKS - PURE AI INTELLIGENCE
 */

import { configureStore } from '@reduxjs/toolkit'
import authSlice from './auth/authSlice'
import uiSlice from './ui/uiSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: import.meta.env.DEV,
})

// Export types explicitly
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Export store as default export
export default store